export default "__VITE_ASSET__Dul$BVc6__"